const TOKEN_KEY = 'exagent_console_token';
const USER_ID_KEY = 'exagent_console_user_id';
const USERNAME_KEY = 'exagent_console_username';
const LANGUAGE_KEY = 'exagent_console_language';

export function getToken() {
  return window.localStorage.getItem(TOKEN_KEY) || '';
}

export function setToken(token) {
  window.localStorage.setItem(TOKEN_KEY, token || '');
}

export function getUserId() {
  return window.localStorage.getItem(USER_ID_KEY) || '';
}

export function setUserId(userId) {
  window.localStorage.setItem(USER_ID_KEY, userId || '');
}

export function getUsername() {
  return window.localStorage.getItem(USERNAME_KEY) || '';
}

export function setUsername(username) {
  window.localStorage.setItem(USERNAME_KEY, username || '');
}

export function getLanguage() {
  return window.localStorage.getItem(LANGUAGE_KEY) || 'en';
}

export function hasLanguage() {
  return !!window.localStorage.getItem(LANGUAGE_KEY);
}

export function setLanguage(language) {
  window.localStorage.setItem(LANGUAGE_KEY, language || 'en');
}

export function clearAuth() {
  window.localStorage.removeItem(TOKEN_KEY);
  window.localStorage.removeItem(USER_ID_KEY);
  window.localStorage.removeItem(USERNAME_KEY);
}



// WEBPACK FOOTER //
// ./src/store/index.js